export default __webpack_public_path__ + "static/media/CV_v1.9a75a79a.pdf";